import React, { useState } from 'react';
import './FAQSection.css';

const faqs = [
  { question: "What if I don't have access to a printer?", answer: "No printer, no problem! Stop by our ticketing booth at the event and we'll print your tickets for you." },
  { question: 'I accidentally deleted my ticket email. What now?', answer: "Contact our support team and we'll resend your ticket confirmation right away." },
  { question: "I don't see the download button in my email.", answer: "Check your spam or junk folder. If it's still missing, contact support and we'll resend it." },
  { question: 'Can I use my phone instead of printing?', answer: 'Absolutely. Just show the QR code from your confirmation email at the event entrance.' },
  { question: 'How can I request a refund?', answer: 'Refund requests can be made up to 48 hours before the event. Reach out to our support team for help.' },
  { question: 'How secure is the online ticketing process?', answer: 'We use industry-standard encryption and trusted payment processors to keep your data and payments safe.' },
];

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex((prev) => (prev === i ? null : i));
  };

  return (
    <div className="faq-section">
      <h2 data-aos="fade-up">Frequently Asked Questions</h2>
      <p className="faq-subheading" data-aos="fade-up" data-aos-delay="50">Got questions? We've got answers.</p>
      <div className="faq-container">
        {faqs.map((faq, i) => (
          <div key={i} className={`faq-item ${openIndex === i ? 'open' : ''}`}>
            <button className="faq-question" onClick={() => toggle(i)}>
              <span>{faq.question}</span>
              <span className="faq-chevron">▼</span>
            </button>
            <div className="faq-answer">
              <div className="faq-answer-inner">{faq.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQSection;